import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
// ---------------------------------------------------------------------------
// StickerAnnotationView — inner visual for a sticker annotation.
//
// `MarkInteractiveView` (in `annotation-view.tsx`) renders the outer
// wrapper, gesture handlers, and resize/rotate handles. This file's
// job is just the sticker's pixel content: a 48×48 translucent blue
// square placeholder until real sticker assets ship. The
// `data-sticker-id` attribute exposes `content.stickerId` so the
// asset-swap follow-up can switch on it without touching the
// surrounding gesture scaffold.
// ---------------------------------------------------------------------------
export const StickerAnnotationView = memo(function StickerAnnotationView({ annotation, }) {
    if (annotation.type !== "sticker")
        return null;
    return (_jsx("span", { className: "annotation-view__sticker-inner", "data-sticker-id": annotation.content.stickerId, "aria-hidden": true }));
});
